import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function CampoForm({
  values,
  handleChange,
  handleSubmit,
  onCancel,
  loading,
}) {
  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        flex: 1,
        margin: 15,
      }}
      onSubmit={handleSubmit}
    >
      <label>
        Campo
        <input
          value={values.campo}
          className="form-control"
          onChange={handleChange}
          name="campo"
          id="campo"
        />
      </label>
      <label>
        Acronimo
        <input
          value={values.acronimo}
          className="form-control"
          onChange={handleChange}
          name="acronimo"
          id="acronimo"
        />
      </label>
      <label>
        En cosecha
        <select
          className="form-control"
          onChange={handleChange}
          id="cosecha"
          name="cosecha"
          value={values.cosecha}
        >
          <option value="1">Si</option>
          <option value="0">No</option>
        </select>
      </label>
      <label>
        Externo
        <select
          className="form-control"
          onChange={handleChange}
          id="externo"
          name="externo"
          value={values.externo}
        >
          <option value="1">Si</option>
          <option value="0">No</option>
        </select>
      </label>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}
      >
        <button
          className="btn btn-success mt-4"
          type="submit"
          disabled={loading}
          style={{ flex: 1 }}
        >
          {loading && <FontAwesomeIcon icon="fa-solid fa-spinner" spin />}
          Guardar
        </button>
        {onCancel && (
          <button
            className="btn btn-danger mt-4"
            onClick={onCancel}
            type="button"
            style={{ flex: 1 }}
          >
            Cancelar
          </button>
        )}
      </div>
    </form>
  );
}
